<template>
  <div>
    <el-table :data="directoryList" style="width: 100%" :show-header="showHeader">
      <el-table-column type="expand">
        <template slot-scope="scope" v-if="scope.row.directoryList">
          <tableTree :directoryList="scope.row.directoryList"></tableTree>
        </template>
      </el-table-column>
      <el-table-column label="编号" prop="directoryNo"></el-table-column>
      <el-table-column label="目录名称" prop="directoryName"></el-table-column>
      <el-table-column label="状态" prop="isAble">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.isAble == 0">正常</el-tag>
          <el-tag type="danger" v-else>禁用</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="400px">
        <template slot-scope="scope">
          <el-button @click="addChild(scope.row.id)" type="success" size="mini">添加子级</el-button>
          <el-button @click="editDirectory(scope.row)" type="primary" size="mini">修改</el-button>
          <el-button @click="delDirectory(scope.row.id)" type="danger" size="mini">删除</el-button>
          <el-button
            v-if="scope.row.isAble == 0"
            @click="statusChange(scope.row.id)"
            type="warning"
            size="mini"
          >禁用</el-button>
          <el-button v-else @click="statusChange(scope.row.id)" type="warning" size="mini">启用</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: "tableTree",
  props: {
    directoryList: Array
  },
  data() {
    return {
      showHeader: false
    };
  },
  mounted() {},
  methods: {
    addChild(id) {
      this.$store.commit("newAddChildDirectory", id);
    },
    editDirectory(row) {
      this.$store.commit("newEditDirectory", row);
    },
    delDirectory(id) {
      this.$store.commit("newDelDirectory", id);
    },
    statusChange(id) {
      this.$store.commit("newStatusChangeDirectory", id);
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/tableTree.vue